/**
 * Ramme for alle indloggede sider: header (desktop-nav), mobil bundmenu,
 * kundevisningsbanner, driftsbesked-popup og firma-status-vagt.
 */
import { Outlet } from "react-router-dom";
import { ImpersonationBanner } from "@/features/sales/components/ImpersonationBanner";
import { CompanyStatusGate } from "@/features/auth/components/StatusScreen";
import { Header } from "./Header";
import { HiddenPricesBanner } from "./HiddenPricesBanner";
import { Footer } from "./Footer";
import { MobileNav } from "./MobileNav";
import { SystemAlertPopup } from "./SystemAlertPopup";
import { PWAPrompts } from "./PWAPrompts";
import { OnboardingDialog } from "@/features/auth/components/OnboardingDialog";

export function AppLayout() {
  return (
    <CompanyStatusGate>
      <div className="flex min-h-dvh flex-col bg-background">
        <ImpersonationBanner />
        <Header />
        <HiddenPricesBanner />
        <main className="mx-auto w-full max-w-[1400px] flex-1 px-4 pb-24 pt-4 md:pb-10">
          <Outlet />
        </main>
        <Footer />
        <MobileNav />
        <SystemAlertPopup />
        <OnboardingDialog />
        <PWAPrompts />
      </div>
    </CompanyStatusGate>
  );
}
